<h1 mat-dialog-title class="dialog-title">
  Submit for Review
</h1>

<div mat-dialog-content class="dialog-content">
  <p class="dialog-p">
    The application is ready to be submitted.
  </p>
  <p class="dialog-p dialog-p--last">
    Would you like to submit the application?
  </p>

  <mat-checkbox
    [(ngModel)]="isCertified"
    class="cert-checkbox">
    By checking this box, I certify under penalty of perjury that all information I have provided
    is true and correct to the best of my knowledge.
  </mat-checkbox>
</div>

<div mat-dialog-actions class="dialog-actions">
  <button mat-raised-button type="button" (click)="onClickNo()">No</button>

  <button
    mat-raised-button
    color="accent"
    type="button"
    [disabled]="!isCertified || disableGrantSave"
    (click)="onClickYes()">
    Yes
  </button>
</div>
